import LoadingUserLayout from "./LoadingUserLayout";

export default LoadingUserLayout;
